import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MostaSelect = _resolveComponent("MostaSelect")!

  return (_ctx.modelValue && _ctx.modelValue.ElementId)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_MostaSelect, {
          modelValue: _ctx.widthValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.widthValue) = $event)),
          class: "q-mb-xs",
          label: _ctx.$t('element_width'),
          options: _ctx.widthOptions
        }, null, 8, ["modelValue", "label", "options"])
      ]))
    : _createCommentVNode("", true)
}